import PageShell from "./PageShell";
import WhatToExpect from "@/components/site/WhatToExpect";
import Testimonials from "@/components/site/Testimonials";
import Booking from "@/components/site/Booking";

export default function BookPage() {
  return (
    <PageShell testId="page-book">
      <Booking />
      <WhatToExpect />
      <Testimonials />
    </PageShell>
  );
}
